module.exports = __webpack_public_path__ + "static/media/niuAndroid.b1041ffe.png";